/**
 * Prevents scroll jumps after Contact Shopify Forms submit.
 */
(function () {
  'use strict';

  const guards = new Set();
  let lockedY = 0;
  let patched = false;

  const native = {
    scrollTo: window.scrollTo.bind(window),
    scroll: window.scroll.bind(window),
    scrollBy: window.scrollBy.bind(window),
    scrollIntoView: Element.prototype.scrollIntoView,
  };

  function readLockedY() {
    if (document.body.classList.contains('contact-modal-open')) {
      const fromTop = Math.abs(Number.parseInt(document.body.style.top || '0', 10));
      if (fromTop > 0) return fromTop;

      const fromData = Number.parseInt(document.body.dataset.contactScrollY || '', 10);
      if (!Number.isNaN(fromData)) return fromData;
    }

    return lockedY || window.scrollY;
  }

  function restoreScroll() {
    const y = readLockedY();
    lockedY = y;
    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;

    html.style.scrollBehavior = 'auto';

    try {
      native.scrollTo.call(window, { top: y, left: 0, behavior: 'instant' });
    } catch {
      native.scrollTo.call(window, 0, y);
    }

    html.style.scrollBehavior = previousBehavior;
    window.cervusHeaderScroll?.syncScrollY?.(y);
  }

  function isGuardActive() {
    return guards.size > 0 || document.body.classList.contains('contact-modal-open');
  }

  function patchScrollMethods() {
    if (patched) return;

    window.scrollTo = function (...args) {
      if (!isGuardActive()) return native.scrollTo.apply(window, args);
      restoreScroll();
    };

    window.scroll = function (...args) {
      if (!isGuardActive()) return native.scroll.apply(window, args);
      restoreScroll();
    };

    window.scrollBy = function (...args) {
      if (!isGuardActive()) return native.scrollBy.apply(window, args);
      restoreScroll();
    };

    Element.prototype.scrollIntoView = function (...args) {
      if (!isGuardActive()) return native.scrollIntoView.apply(this, args);
      restoreScroll();
    };

    patched = true;
  }

  function unpatchScrollMethods() {
    if (!patched) return;

    window.scrollTo = native.scrollTo;
    window.scroll = native.scroll;
    window.scrollBy = native.scrollBy;
    Element.prototype.scrollIntoView = native.scrollIntoView;
    patched = false;
  }

  function activate(id) {
    if (!id) return;

    if (guards.size === 0) {
      lockedY = window.scrollY;
      patchScrollMethods();
    }

    guards.add(id);
  }

  function deactivate(id) {
    guards.delete(id);

    if (guards.size === 0 && !document.body.classList.contains('contact-modal-open')) {
      unpatchScrollMethods();
    }
  }

  function hold(durationMs = 1500) {
    lockedY = readLockedY();
    activate('hold');

    const startedAt = performance.now();

    function frame(now) {
      restoreScroll();
      if (now - startedAt < durationMs) {
        requestAnimationFrame(frame);
      }
    }

    requestAnimationFrame(frame);
    window.setTimeout(() => deactivate('hold'), durationMs);
  }

  window.cervusFormScrollGuard = {
    activate,
    deactivate,
    hold,
    restore: restoreScroll,
    save: () => {
      lockedY = window.scrollY;
      return lockedY;
    },
  };
})();
